import React from 'react';
import { Gift, Calendar, ArrowRight } from 'lucide-react';

const PromoBanner: React.FC = () => {
  return (
    <div className="promo-banner">
      <div className="container">
        <div className="promo-content">
          <div className="promo-icon">
            <Gift size={32} />
          </div>
          <div className="promo-text">
            <h3>¡Tu Moodle Listo Ya!</h3>
            <p>Plataforma Moodle completamente <strong>configurada y administrada</strong></p>
          </div>
          <div className="promo-features">
            <div className="promo-feature">
              <Calendar size={16} />
              <span>Listo en minutos</span>
            </div>
            <div className="promo-feature">
              <span>🚀</span>
              <span>Hosting optimizado</span>
            </div>
            <div className="promo-feature">
              <span>💪</span>
              <span>Administración incluida</span>
            </div>
          </div>
          <div className="promo-cta">
            <a href="#contacto" className="btn btn-accent">
              Comenzar Ahora
              <ArrowRight size={18} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoBanner;